import React from 'react';

import { Marker } from 'react-leaflet';
import { Point, DivIcon, LatLngTuple } from 'leaflet';

import classes from './highlight-marker.module.scss';

const markerSize = 40;
const icon = new DivIcon({
  html: `<img class=${classes.bounce} src="/static/img/marker-highlight.svg"></img>`,
  iconSize: new Point(markerSize, markerSize),
  iconAnchor: [markerSize / 2, markerSize / 2],
  className: classes.bouncyPointerWrapper,
});

type Props = {
  coordinates: LatLngTuple;
};

export const HighlightMarker = ({ coordinates }: Props) => (
  <Marker
    icon={icon}
    position={[coordinates[1], coordinates[0]] as LatLngTuple}
    zIndexOffset={1001}
    interactive={false}
  />
);
